import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import Footer from "components/Footer/Footer.jsx";
// sections for this page
import HeaderLinks from "components/Header/HeaderLinks.jsx";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.jsx";

import { withNamespaces } from "react-i18next";

import SectionLinksGeneral from "./Sections/SectionLinksGeneral.jsx";
import SectionLinksOrganizations from "./Sections/SectionLinksOrgnizations.jsx";

import { checkTrans } from 'helpers';

class AdditionalInfoPage extends React.Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    checkTrans('links');
  }

  render() {
    const { t, classes } = this.props;

    return (
      <div>
        <Header
          brand="CLCCro"
          links={<HeaderLinks dropdownHoverColor="primary" />}
          fixed
          color="transparent"
          changeColorOnScroll={{
            height: 300,
            color: "white"
          }}
        />
        <Parallax image={require("assets/img/bkg/sergii-gulenok-61955-unsplash-sm.jpg")} filter="dark" small>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem
                md={8}
                sm={8}
                className={classNames(
                  classes.mlAuto,
                  classes.mrAuto,
                  classes.textCenter
                )}
              >
                <h1 className={classes.title}>{t("pagecontent:info-title")}</h1>
                <h4>{t("pagecontent:info-subtitle")}</h4>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <SectionLinksGeneral />
            <SectionLinksOrganizations />
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}

export default withNamespaces()(withStyles(aboutUsStyle)(AdditionalInfoPage));
